import React from 'react';
import styled from 'styled-components';
import BulletinGallery from '../components/BulletinGallery';

const BulletinPageContainer = styled.div`
  min-height: 100vh;
`;

const HeroSection = styled.section`
  background: linear-gradient(135deg, #2c5aa0 0%, #1e3a8a 100%);
  color: #fff;
  padding: 80px 0;
  text-align: center;

  @media (max-width: 768px) {
    padding: 60px 0;
  }
`;

const HeroContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0 15px;
  }
`;

const Title = styled.h1`
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    font-size: 32px;
  }
`;

const ContentSection = styled.section`
  padding: 80px 0;
  background: #fff;

  @media (max-width: 768px) {
    padding: 60px 0;
  }
`;

const ContentWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0 15px;
  }
`;

const Bulletin: React.FC = () => {
  return (
    <BulletinPageContainer>
      <HeroSection>
        <HeroContent>
          <Title>주보</Title>
        </HeroContent>
      </HeroSection>

      <ContentSection>
        <ContentWrapper>
          <BulletinGallery />
        </ContentWrapper>
      </ContentSection>
    </BulletinPageContainer>
  );
};

export default Bulletin;